// Invite wizard step 3 — standard or VIP. RON-5466 Phase 2. Prototype: `InviteStep3`.
//
// Maps to `tblvisitor_visit.type`. VIP is a real flag the kiosk and host notifications react to,
// not just a badge.

import { useTranslation } from "react-i18next";

import { VISIT_TYPE } from "../visitorConstants.js";

const OPTIONS = [
  { value: VISIT_TYPE.STANDARD, labelKey: "react_visitors_type_standard" },
  { value: VISIT_TYPE.VIP, labelKey: "react_visitors_vip" },
];

const VisitorTypeStep = ({ value, onChange }) => {
  const { t } = useTranslation("common");

  return (
    <div className="visitor-card">
      <p className="visitor-card__title">{t("react_visitors_type_title")}</p>
      <p className="visitor-card__hint">{t("react_visitors_type_hint")}</p>

      <div className="visitor-type-options" role="radiogroup">
        {OPTIONS.map((option) => {
          const isSelected = value === option.value;

          return (
            <button
              key={option.value}
              type="button"
              role="radio"
              aria-checked={isSelected}
              className={`visitor-chip visitor-chip--type${
                isSelected ? " visitor-chip--on" : ""
              }`}
              onClick={() => onChange(option.value)}
            >
              {t(option.labelKey)}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default VisitorTypeStep;
